const SESSION_MAX_TIME_IN_MS = 1800000, // 30 minutes in milliseconds
  SESSION_HALF_TIME_IN_MS = SESSION_MAX_TIME_IN_MS / 2, // 15 minutes in milliseconds,
  SESSION_5_MINUTES_TO_GO_IN_MS = SESSION_MAX_TIME_IN_MS - 300000; // 5 minutes in milliseconds

export { SESSION_MAX_TIME_IN_MS, SESSION_HALF_TIME_IN_MS, SESSION_5_MINUTES_TO_GO_IN_MS };
